import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface ImpactsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<ImpactsServiceData>(db, 'impactsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
